import { FormBlock, Toggle } from '@qbe/ads-blocks-forms';
import { Typography } from '@qbe/ads-core';
import React, { useState } from 'react';

import { simpleQuestionOptions } from '~/constants/questions';
import { useAppContent, useAppDispatch, useExtraInfo } from '~/hooks';
import { updateNeedInterestedParties } from '~/slices/extraInfo';
import { SimpleQuestionAnswer } from '~/types/enums';
import { getSimpleQAValue } from '~/utils';

import { ContextualHelpWithButton } from '../../components-ds/ContextualHelp/ContextualHelpWithButton';

interface NeedInterestedPartyProps {
  onSelect?: (isRegistered: boolean) => void;
}

const NeedInterestedParty: React.FC<NeedInterestedPartyProps> = ({ onSelect }) => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.extraInfoMoreBusinessDetailsLandlord',
  });

  const { needInterestedParties } = useExtraInfo();
  const [_needInterestedParties, setNeedInterestedParties] = useState(
    getSimpleQAValue(needInterestedParties)
  );

  const dispatch = useAppDispatch();

  const onToggleChangeHandler = (val: string | null) => {
    const needParties = val === SimpleQuestionAnswer.Yes;
    setNeedInterestedParties(val!);
    dispatch(updateNeedInterestedParties(needParties));
    onSelect?.(needParties);
  };

  return (
    <FormBlock
      preset="toggle"
      data-track="do you need to add an interested third party"
      data-track-value="capture"
    >
      <Toggle
        title={getTextContent('fields.needInterestedParties.title')}
        subtitle={getTextContent('fields.needInterestedParties.description')}
        titleSuffix={
          <ContextualHelpWithButton tracking="help: Do you need to add an interested Party?">
            <Typography>
              {getJSXContent('contextualhelpers.needInterestedParties.description')}
            </Typography>
          </ContextualHelpWithButton>
        }
        optionList={simpleQuestionOptions.map(({ text, value }) => ({
          id: text,
          value,
          label: text,
          onChange: (e) => {
            onToggleChangeHandler(e.target.value);
          },
          checked: value === _needInterestedParties,
        }))}
        defaultValue={_needInterestedParties}
        name="needInterestedParties"
      />
    </FormBlock>
  );
};

export default NeedInterestedParty;
